<template>
  <div class="style-text">
    <!-- <img :src="imgUrl" @load='load' /> -->
    <van-image class="img-box" :src="imgUrl"  fit="cover" />
    <van-image  class="button" :src="btnImg" @click="jumpApplet" />
    <!-- <div class="button" @click="jumpApplet"></div> -->
  </div>
</template>

<script>
import loadingMixin from '@/mixins/loading-mixin'
import imgUrl from '@/assets/images/style-home.png'
import btnImg from '@/assets/images/style-home-btn.png'
export default {
   mixins: [loadingMixin],
  data(){
    return {
      parames: {},
      imgUrl: imgUrl,
      btnImg: btnImg,
    }
  },
  mounted() {
    // this.showLoading();
    this.$api.drawlots.getDictData('wx_url_link_params')
      .then(res => {
        this.parames = {}
        res.data.forEach(item => {
          this.parames[item.dictDataCode] = item.dictDataValue
        })
      })

  },
  methods:{
    jumpApplet() {
      this.$api.activityMgmt.urlLink(this.parames).then(res => {
        location.href=res.data
      })
    },
    load(e) {
      this.hideLoading();
    }
  }
}
</script>

<style lang="stylus" scoped>
  .style-text {
    position: relative;
    .img-box {
      display: block;
      width: 100%;
      height: 100vh;
    }
    .button {
      position: absolute;
      left: 50%;
      bottom: 50px;
      width: 176px;
      height: 36px;
      transform: translate(-50%, 0);
    } 
  }
</style>